import styled from "styled-components";

export const Container = styled.div`
  border: transparent;
  box-shadow: 0 0 5px var(--gray-800);
  width: 100%;
  background-color: var(--gray-800);
`;

export const ContainerCard = styled.div`
  background-color: var(--gray-800);
`;

export const Cover = styled.div`
  background-size: cover;
  background-position: center center;
  border-radius: 100px;
  height: 150px;
  width: 150px;
`;

export const SchoolStyle = styled.h3`
  font-size: 1.5rem;
  font-weight: bold;
`;
